import { createContext, useContext } from "react";
import type { U2000TimesheetWeekView } from "../../../u2000Core/hooks/useU2000TimesheetWeekView";

export const U3130TimesheetWeekViewContext = createContext<U2000TimesheetWeekView | null>(null);

/** Vue semaine partagée par les onglets du détail — fournie par `U3130TimesheetWeekViewProvider`. */
export function useU3130TimesheetWeekView(): U2000TimesheetWeekView {
  const value = useContext(U3130TimesheetWeekViewContext);
  if (value == null) {
    throw new Error("useU3130TimesheetWeekView doit être utilisé sous U3130TimesheetWeekViewProvider");
  }
  return value;
}
